import { Suspense, lazy } from 'react';
import { Toaster } from 'react-hot-toast';

import { CandidateListSkeleton } from '@/components/skeleton.effect';

const CandidateListComponent = lazy(() => import('@/components/candidateList.component'));

export const ExpertsProjectDetail = () => {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <Toaster />

      <Suspense fallback={<CandidateListSkeleton />}>
        <CandidateListComponent />
      </Suspense>
    </div>
  );
};
